export const siteUrl = "https://api.3sual.az/";
// export const siteUrl = "https://3sual.site/";
export const testUrl = "https://test.3sual.site/";
export const local = "https://localhost:44352/";

export default siteUrl;
